<template>
    <div>
     <!-- <v-app-bar fixed height=65>
         <div class="d-flex align-center">
            <v-img
            alt="Vuetify Logo"
            
            :src="storeLogo"
            transition="scale-transition"
            max-height='50'
            max-width="250"
            />
            
         </div>
         <v-spacer></v-spacer>
           <v-btn icon append :to="{name:'Cart'}"> 
                <v-icon>mdi-cart-outline</v-icon>
            </v-btn>
            <v-btn icon>
                <v-icon>mdi-account-circle-outline</v-icon>
            </v-btn>
        
    </v-app-bar> -->

    <v-dialog
      v-model="dialog1"
      max-width="500"
    >
      <v-card>
       <v-card-title class="headline d-flex justify-center">
           1 Last Step to Go!
        </v-card-title>
       <v-card-text>
           <v-row v-if="isloginless" justify="center">
               <v-col lg=12>
                   <v-form>

                    <v-stepper v-model="e1"> 

                        <v-stepper-header>
                            <v-stepper-step :complete="e1 > 1" step="1">Contact Details</v-stepper-step>

                            <v-divider></v-divider>

                            <v-stepper-step :complete="e1 > 2" step="2">Delivery Address</v-stepper-step>
                        </v-stepper-header>
                        <v-stepper-items>
                            <v-stepper-content step="1">
                                <v-form ref="form1">
                                    <v-text-field v-model="name" :rules="[rules.required]" label='Full Name' solo dense></v-text-field>
                                    <v-text-field v-model="phone" :rules="[rules.required]" label='Phone' solo dense></v-text-field>
                                    <v-text-field v-model="email" :rules="[rules.required]" label='Email' solo dense></v-text-field>
                                    <v-btn class='mb-5' block color="primary" @click="submitForm1">
                                        Next
                                    </v-btn>
                                </v-form>
                            </v-stepper-content>
                            <v-stepper-content step="2">
                                <v-form ref="form2">
                                    <v-text-field v-model="address1" :rules="[rules.required]" label='Address Line 1' solo dense></v-text-field>
                                    <v-text-field v-model="address2" label='Address Line 2' solo dense></v-text-field>
                                    <v-text-field v-model="city" :rules="[rules.required]" label='City' solo dense></v-text-field>
                                    <v-text-field v-model="state" :rules="[rules.required]" label='State' solo dense></v-text-field>
                                    <v-text-field v-model="pincode" :rules="[rules.required]" label='PIN Code' solo dense></v-text-field>
                                    <v-btn class='mb-5' block color="primary" @click="submitForm2">
                                        Checkout
                                    </v-btn>
                                </v-form>
                                <!-- <v-form ref="form3" method="POST" :action="this.myBaseURL + '/order/create/' + this.$route.params.store_slug">
                                    <v-text-field type="hidden" v-show="false" name="customer_id" ref="customer_id"></v-text-field> 
                                    <v-text-field type="hidden" v-show="false" name="unique_id" ref="unique_id"></v-text-field> 
                                    <v-btn class='mb-5' block color="primary" type="submit" v-show="false" ref="myBtn">
                                        Checkout
                                    </v-btn>
                                </v-form> -->
                            </v-stepper-content>
                        </v-stepper-items>
                    </v-stepper>
                   </v-form>
               </v-col>
           </v-row>
           <v-row justify='center' v-else>
               <v-col lg=8>
                    <v-img :src="require('../assets/checkout_modal.svg')" contain/>
               </v-col>
           </v-row>
          
       </v-card-text>

        <v-card-actions v-if="!isloginless" class='pl-10 pr-10 d-flex justify-center flex-column'>
        
          <v-btn
          @click="login"
          class='mb-5'
          block
            color="primary"
          >
            Login
          </v-btn>
          <a class='mb-2' @click='isloginless=true'>Skip Login</a>

          
        </v-card-actions>
        <v-card-actions v-else class='pl-10 pr-10 d-flex justify-center flex-column'>
          <a class='mb-2' @click='login'>Login Instead</a>
        </v-card-actions>

        
        
       
      </v-card>
    </v-dialog>
        <v-container>
            <v-row justify='center'>
                <v-col lg=6>
            
                <div class='mt-10'>
           
                <h1>My Cart </h1>
                    <CartEntry  v-for='item in items' :key='item.id' :productId="item.id" :productName='item.name' :productPrice="item.price" :qty='item.qty' :productImg="item.img" @onQtyChange="updateCartData" @onProductRemove="deleteCartData" />
                
                <div id='grand_total_container'>
                    <v-divider class='mt-5'></v-divider>
                    <div class='pa-4'>
                        <v-row justify="space-between">
                        <h2>Grand Total : <span class='font-weight-light'> Rs. {{getTotal}}</span> </h2>
                        <div>
                             <v-row>
                            
                                <v-btn @click="emptyCart">
                                    Empty Cart
                                </v-btn>
                                <v-btn class='ml-2' color='success' @click="checkLogin">
                                    Checkout
                                </v-btn>
                            </v-row>
                        </div>
                       
                        
                        </v-row>
                    </div>
                    
                </div>
           </div>
                </v-col>
            </v-row>
            
            
        </v-container>
    </div>
    
</template>
<style scoped>
#grand_total_container
{
    /* max-width:600px;    */
}
.container
{
    margin-top:60px;
}

</style>
<script>
/*global myBaseURL*/
import axios from 'axios';
import CartEntry from '@/components/CartEntry.vue';

export default {
    name:'CartPage',
    components:{
        CartEntry
    },
    data (){
        return {
                myBaseURL : myBaseURL,
                e1: 1,
                isloginless:false,
                storeName:'Store',
                storeLogo:'',
                dialog1:false,
                // cartTotal: 0,
                items:[],
                cart_id : 0,
                unique_id : '',
                cart_items : [],
                name : '',
                email : '',
                phone : '',
                address1 : '',
                address2 : '',
                city : '',
                state : '',
                pincode : '',
                rules:{
                    required: value => !!value || 'Required.',
                    counter: value => value.length <= 25 || 'Max 25 characters',
                },
                customer_id : 0
                // handleNameRules : [
                //     v => !!v || 'Required.',
                //     v => (v && v.length <= 25) || 'Max 25 characters',
                //     v => {
                //         var cnt = 0;
                //         for(var i=0;i<v.length;i++)
                //         {
                //             if ((v.charCodeAt(i) >= 65 && v.charCodeAt(i) <= 90) || (v.charCodeAt(i) >= 97 && v.charCodeAt(i) <= 122))
                //             {
                //                 cnt++;
                //             }
                //         }
                //         return cnt >= 2 || 'Atleast 2 alphabets';
                //     },
                //     v => v[0] != '.' || '. is not allowed at start',
                //     v => v[v.length - 1] != '.' || '. is not allowed at end',
                //     v => /^(?!.*\.\.)(?!.*\.$)[^\W][\w.]{1,29}$/.test(v) || 'Only _ and . are allowed'
                // ],
            }
    },
    computed : {
        getTotal(){
            var total = 0
            this.items.forEach(element => {
                total = total + (element.price * element.qty)
            })
            console.log(total);
            // this.cartTotal = total;
            return total
        }
    },
    created(){
        this.$emit('showAppBar');
        this.unique_id = window.localStorage.getItem('unique_id');
        var that = this;
         axios.request({
            url: '/store/home/'+this.$route.params.store_slug,
            method: 'GET',
            baseURL: myBaseURL,
            // headers: {
            //     'Authorization': 'Bearer '+ window.localStorage.access_token
            // }
        }).then(response => {
            // this.storeName=response.data.name
            // this.storeLogo=response.data.logo
            this.$emit('showLogo',response.data.logo,response.data.slug);
            if(this.unique_id && this.unique_id != '')
            {
                axios.request({
                    url: '/cart/' + this.$route.params.store_slug + '/' + this.unique_id,
                    method: 'GET',
                    baseURL: myBaseURL,
                    // headers: {
                    //     'Authorization': 'Bearer '+ window.localStorage.access_token
                    // }
                }).then(response => {
                    console.log(response.data);
                    var cart_items = response.data.cart_items.cart_items;
                    cart_items.forEach(element => {
                        console.log(element);
                        that.items.push({
                            id : element.id,
                            product : element.product.id,
                            variant : element.product.variant_id,
                            name : element.product.name,
                            price : element.product.price,
                            qty : element.product.qty,
                            img: element.product.img
                        })
                    });
                    that.cart_id = response.data.cart_items.id;

                }).catch(e => {
                    console.log(e)
                })
            }
        }).catch(e => {
            console.log(e)
        })
    },
    methods : ({
        submitForm1()
        {
            if(this.$refs.form1.validate())
            {
                this.e1=2;
            }
        },
        submitForm2()
        {
            var that = this;
            if(this.$refs.form2.validate())
            {
                axios.request({
                    url: '/loginless/customer/details/' + that.$route.params.store_slug,
                    method: 'POST',
                    baseURL: myBaseURL,
                    data : {
                        'name' : that.name,
                        'email' : that.email,
                        'phone' : that.phone,
                        'address1' : that.address1,
                        'address2' : that.address2,
                        'city' : that.city,
                        'state' : that.state,
                        'pincode' : that.pincode,
                        'unique_id' : that.unique_id
                    }
                }).then(response => {
                    console.log(response.data);
                    console.log('Success Data');
                    that.customer_id = response.data.id;
                    
                    window.location.href = myBaseURL + '/order/create/' + that.$route.params.store_slug + '/' + that.unique_id + '/' + that.customer_id;
                    
                }).catch(e => {
                    console.log(e);
                    console.log('Fail Data');
                });
            }
        },
        login()
        {
            this.$router.push({ path: '/' + this.$route.params.store_slug + '/login', query: { redirect: '/' + this.$route.params.store_slug + '/cart' }  })
            
        },
        loginless()
        {
            this.$router.push({ path: '/' + this.$route.params.store_slug + '/checkout_wo'})

        },
        checkLogin(){
            var token = window.localStorage.getItem('access_token');
            var that = this;
            if(token)
            {
                axios.request({
                    url: '/checkCustomerToken/' + that.$route.params.store_slug,
                    method: 'GET',
                    baseURL: myBaseURL,
                    headers: {
                        'Authorization': 'Bearer '+ token
                    }
                }).then(response => {
                    console.log(response.data);
                    if(response.data.token)
                    {
                        that.customer_id = response.data.customer_id;
                        window.location.href = myBaseURL + '/order/create/' + that.$route.params.store_slug + '/' + that.unique_id + '/' + that.customer_id;
                    }
                }).catch(e => {
                    console.log(e)
                    that.dialog1 = true;
                })
            }
            else
            {
                that.dialog1=true;
            }
        },
        updateCart()
        {
            var that = this;
            axios.request({
                url: '/cart/',
                method: 'POST',
                baseURL: myBaseURL,
                data : {
                    'store_slug' : that.$route.params.store_slug,
                    'unique_id' : that.unique_id,
                    'cart_items' : that.items,
                }
            }).then(response => {
                console.log(response.data);
                if(response.data.status == true)
                {
                    window.localStorage.setItem('unique_id', response.data.unique_id);
                    window.localStorage.setItem('store_slug', response.data.store_slug);
                }
                else
                {
                    window.localStorage.setItem('unique_id', '');
                    this.$router.push({ name: 'Store', params : {store_slug : this.$route.params.store_slug } })
                }
                
                console.log('Success Data');
            }).catch(e => {
                console.log(e);
                console.log('Fail Data');
            });
        },
        emptyCart()
        {
            axios.request({
                url: '/cart/' + this.$route.params.store_slug + '/' + window.localStorage.getItem('unique_id'),
                method: 'DELETE',
                baseURL: myBaseURL,
                // headers: {
                //     'Authorization': 'Bearer '+ window.localStorage.access_token
                // }
            }).then(response => {
                console.log(response.data);
                window.localStorage.setItem('unique_id', response.data.unique_id);
                this.$router.push({ name: 'Store', params : {store_slug : this.$route.params.store_slug } })
            }).catch(e => {
                console.log(e)
            })
        },
        updateCartData(data)
        {
            this.items.find(obj => obj.id === data.id).qty = data.qty;
            this.updateCart();
        },
        deleteCartData(id)
        {
            this.items = this.items.filter(obj => obj.id !== id);
            console.log(this.items);
            this.updateCart();
        }
    })
}
</script>